/**
 * Season-Aware Scoring Rules
 *
 * Provides per-season scoring rules for F1 Fantasy.
 * Only values that differ between seasons are stored here.
 * Position tables, overtakes, positions gained — all unchanged across seasons.
 *
 * Rule changes:
 * - 2023-2025: Sprint DNF = -20, Sprint DQ = -30
 * - 2026+:     Sprint DNF = -10, Sprint DQ = -20
 */

export interface ScoringRules {
  raceDnfPenalty: number;
  sprintDnfPenalty: number;
  fastestLapRace: number;
  fastestLapSprint: number;
  driverOfTheDay: number;
  noQualifyingTimePenalty: number;
  dqQualifying: number;
  dqRace: number;
  dqSprint: number;
}

const RULES_2025: ScoringRules = {
  raceDnfPenalty: -20,
  sprintDnfPenalty: -20,
  fastestLapRace: 10,
  fastestLapSprint: 5,
  driverOfTheDay: 10,
  noQualifyingTimePenalty: -5,
  dqQualifying: -10,
  dqRace: -30,
  dqSprint: -30,
};

const RULES_2026: ScoringRules = {
  raceDnfPenalty: -20,
  sprintDnfPenalty: -10,
  fastestLapRace: 10,
  fastestLapSprint: 5,
  driverOfTheDay: 10,
  noQualifyingTimePenalty: -5,
  dqQualifying: -10,
  dqRace: -30,
  dqSprint: -20,
};

const SEASON_RULES: Record<number, ScoringRules> = {
  2023: RULES_2025,
  2024: RULES_2025,
  2025: RULES_2025,
  2026: RULES_2026,
};

/**
 * Get scoring rules for a given season.
 * Falls back to the latest known rules if the season is not mapped.
 */
export function getScoringRules(season: number): ScoringRules {
  return SEASON_RULES[season] ?? RULES_2026;
}
